"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackPoint = exports.Track = void 0;
/** A flight track */
var Track = /** @class */ (function () {
    function Track() {
    }
    return Track;
}());
exports.Track = Track;
/** An individual track point within the track. */
var TrackPoint = /** @class */ (function () {
    function TrackPoint(lat, lon, alt, t) {
        this.lat = lat;
        this.lon = lon;
        this.alt = alt;
        this.t = t;
    }
    return TrackPoint;
}());
exports.TrackPoint = TrackPoint;
//# sourceMappingURL=Track.js.map